import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useVisibleCategories } from '../../hooks/useVisibleCateogries';
import { ButtonGrid, ButtonGridItem } from '../../../../components/ButtonGrid';
import { Button } from '../../../../components/Button';
import s from './LiteCategories.scss';
import { dataHooks as categoryButtonDataHooks } from '../../components/CategoryButton/datahooks';
import { HelpCircle } from 'wix-ui-icons-common';
import { Divider } from '../../components/Divider/Divider';
import { CategoriesHeader } from './CategoriesHeader/CategoriesHeader';
import { useCurrentCategoryValue, useSetCurrentCategoryValue } from '../../../../context';

export interface LiteCategoriesProps {}

export const LiteCategories: FC<LiteCategoriesProps> = () => {
  const { t } = useTranslation();
  const setCategoryValue = useSetCurrentCategoryValue();
  const currentCategory = useCurrentCategoryValue();
  const visibleCategories = useVisibleCategories({});

  const categoryItems: ButtonGridItem[] = visibleCategories.map(([key, category]) => ({
    key,
    value: key,
    label: t(category.name),
    onClick: setCategoryValue,
    icon: <category.Icon size={24} style={{ color: category.color }} />,
    dataHook: categoryButtonDataHooks.categoryButton(key),
  }));

  const handleRandomCategorySelection = (): void => {
    const randomIndex = Math.floor(Math.random() * categoryItems.length);
    const randomCategory = categoryItems[randomIndex];
    setCategoryValue(randomCategory.value);
  };

  return (
    <Box height="100%" direction="vertical" gap={4}>
      <CategoriesHeader />

      <ButtonGrid items={categoryItems} selectedValue={currentCategory} />

      <Divider />

      <Box width="100%">
        <Button
          onClick={handleRandomCategorySelection}
          label={t('DS_CATEGORY_CHOOSE_FOR_ME')}
          icon={<HelpCircle size="24" />}
          isSelected={currentCategory === 'rts.chooseForMe'}
          dataHook={categoryButtonDataHooks.categoryButton('rts.chooseForMe')}
          className={s.chooseForMe}
          align="center"
        />
      </Box>
    </Box>
  );
};
